export function ExtendZod(schema, ...extensions) {
    const tracker = trackExtensions(schema);
    extensions.forEach((e) => {
        if (!tracker.has(e.id)) {
            tracker.register(e.id);
            Object.defineProperties(schema.prototype, e.value(schema));
        }
    });
}
function trackExtensions(schema) {
    const existingExtensions = schema.prototype['zodExtensions'];
    if (!existingExtensions) {
        schema.prototype['zodExtensions'] = [];
    }
    return {
        has(extensionId) {
            return schema.prototype['zodExtensions'].includes(extensionId);
        },
        register(extensionId) {
            schema.prototype['zodExtensions'].push(extensionId);
        },
        list() {
            return schema.prototype['zodExtensions'];
        }
    };
}
